import { useMemo } from "react";

import isSubscription from "web/utils/page/product/subscription/isSubscription";
import setBenefitGroupTypeParam from "web/utils/page/product/subscription/setBenefitGroupTypeParam";
import processUrlKey from "web/utils/page/product/universal/processUrlKey";

import urls from "web/constants/urls";

import { IProduct } from "web/types/Product";

const useProductUrl = ({
  mb_product_type,
  sku,
  url_key,
}: Pick<IProduct, "mb_product_type" | "sku" | "url_key">) =>
  useMemo(
    () =>
      isSubscription(mb_product_type)
        ? {
            pathname: urls.checkoutSubscriptionConfiguration,
            search: `${setBenefitGroupTypeParam(
              mb_product_type.split("_")[2]
            )}&id=${sku}`,
          }
        : processUrlKey(url_key),
    [mb_product_type, url_key, sku]
  );

export default useProductUrl;
